// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-fab-button {
  width: 3em;
  height: 3em;
  margin-top: 1em;
  margin-right: 0em;
}

ion-fab-button[data-desc]::after {
  position: relative;
  content: attr(data-desc);
  cursor: pointer;
  z-index: 1;
  right: 9.5em;
  bottom: 2em;
  background-color: var(--ion-color-light-contrast);
  padding: 9px;
  border-radius: 10px;
  color: white;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
}`, "",{"version":3,"sources":["webpack://./src/app/common/sharedComponents/labeled-fab-button-entry/labeled-fab-button-entry.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,iDAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,iHAAA;AACF","sourcesContent":["ion-fab-button {\r\n  width: 3em;\r\n  height: 3em;\r\n  margin-top: 1em;\r\n  margin-right: 0em;\r\n}\r\n\r\nion-fab-button[data-desc]::after {\r\n  position: relative;\r\n  content: attr(data-desc);\r\n  cursor: pointer;\r\n  z-index: 1;\r\n  right: 9.5em;\r\n  bottom: 2em;\r\n  background-color: var(--ion-color-light-contrast);\r\n  padding: 9px;\r\n  border-radius: 10px;\r\n  color: white;\r\n  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
